import { BooleanInput, Create, CreateContextProvider, DateTimeInput, Form, required, SaveButton, SelectInput, TextInput, Toolbar, TopToolbar, useCreateController, useNotify, useRecordContext, useRedirect, useTranslate } from 'react-admin';
import { Box, Card, Divider, Stack, Typography, Button as MUIButton, Tooltip, IconButton } from '@mui/material';

import { useEffect, useRef, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { chains } from 'src/assets/data';
import ColorInput from 'src/pages/admin/components/ColorInput';

interface FormProps {
    isCreate: boolean;
}
const ColorForm = (props: FormProps) => {
    const { isCreate } = props;
    const t = useTranslate();
    const redirect = useRedirect();
    const { watch, setValue, trigger } = useFormContext();
    const record = useRecordContext();

    return (
        <>
            <Stack spacing={3} gap={2}>


                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} spacing={2} mb={1}>
                    <Box sx={{ flexBasis: '20%', flexShrink: 0, mt: -1 }}>
                        <Typography variant="body2">{t("module.color.key")}</Typography>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        <TextInput
                            source="key"
                            label=""
                            validate={[required()]}
                            placeholder={t("module.color.key")}
                            fullWidth
                            multiline
                            helperText={<span style={{ color: 'red' }}></span>}
                        />
                    </Box>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} spacing={2} mb={1}>
                    <Box sx={{ flexBasis: '20%', flexShrink: 0, mt: -1 }}>
                        <Typography variant="body2">{t("module.color.name")}</Typography>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        <TextInput
                            source="name"
                            label=""
                            validate={[required()]}
                            placeholder={t("module.color.name")}
                            fullWidth
                            multiline
                            helperText={<span style={{ color: 'red' }}></span>}
                        />
                    </Box>
                </Stack>
                
                <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
                    <Typography
                        variant="body2"
                        sx={{ flexBasis: '20%', flexShrink: 0 }}
                    >
                        {t("module.searchPlaceholder.enable")}
                    </Typography>
                    <Box
                        sx={{ flexGrow: 1 }}
                    >
                        <BooleanInput label='' source="enable" helperText={<span style={{ color: 'red' }}></span>} />
                    </Box>

                </Stack>
                <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
                    <Typography
                        variant="body2"
                        sx={{ flexBasis: '20%', flexShrink: 0 }}
                    >
                        {t("module.searchPlaceholder.enable")}
                    </Typography>
                    <Box
                        sx={{ flexGrow: 1 }}
                    >
                        <ColorInput source="color" label="Color" />
                    </Box>

                </Stack>
            </Stack>
            </>
    );
};

export default ColorForm;
